export const AddWinnerStyles = {
	list: {
		display: 'flex',
		position: 'relative',
		flexDirection: 'column',
		gap: '12px',
		'@media (max-width: 639.98px)': {
			padding: '16px 20px 0',
		},
		'@media (min-width: 1200px)': {
			paddingTop: '20px',
		},
	},

	row: {
		display: 'grid',
		gridTemplateColumns: '1fr 1fr 1fr 40px',
		gap: '12px',
		alignItems: 'center',

		'@media (max-width: 767.98px)': {
			gridTemplateColumns: '1fr',
		},
	},

	removeBtn: {
		'@media (max-width: 767.98px)': {
			display: 'none',
		},
	},

	addButtonWrapper: {
		display: 'flex',
		justifyContent: 'center',
		marginTop: '16px',

		'@media (min-width: 1200px)': {
			marginBottom: '80px',
		},
	},

	addBtn: {
		width: 'fit-content',

		'@media (max-width: 639.98px)': {
			position: 'fixed',
			bottom: '16px',
			left: '16px',
			right: '16px',
		},
	},

	drawer: {
		'@media (min-width: 1200px)': {
			display: 'none',
		},
	},
	popup: {
		display: 'flex',
		gap: '16px',
		padding: '20px',
		height: '100%',
	},

	modal: {
		'.MuiPaper-root': {
			position: 'relative',
			maxWidth: '1170px',
			width: '100%',
			padding: '48px 120px',
			margin: '0 15px',

			'@media (max-width: 639.98px)': {
				padding: '40px 20px 20px',
			},
		},
	},
	cancelBtn: {
		'@media (max-width: 639.98px)': {
			display: 'none',
		},
	},
};
